import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import notify from '../../../../../shared/feedback/notifications';
import {
    Button,
    ButtonGroup,
    Checkbox,
    Col,
    ControlLabel,
    FormControl,
    FormGroup,
    HelpBlock,
    Panel,
    Row
} from 'react-bootstrap';
import * as Features from '../../../../../shared/Features';
import * as actions from '../actions/PlanOrderActions';
import { assign } from '../../../../../shared/Assign';
import { Translate } from '../../../../../shared/LanguageService';
import { handleError } from '../../../../../shared/ErrorCatching';
import { getSiteName, Zentuvo } from '../../../../../shared/Site';
import {
    IAnnotationViewModel,
    ISavePlanOrderModel,
    ISelect,
    ISendPlanOrderModel,
    IUpdateSortModel,
    IUpdateStorey
} from '../Entities';
import { AnnotationFloorCrop, AnnotationNormal } from '../../../../planannotation/AnnotationTypes';
import FormValidationService from '../../../../../shared/form/FormValidationService';
import Dropzone from '../../../../../components/common/Dropzone';
import PlanAnnotationTool from '../../../../planannotation/PlanAnnotationTool';
import StoreySelect from '../../../../../components/common/planOrder/StoreySelect';
import StoreySort from '../../../../../components/common/planOrder/StoreySort';
import ConfirmationModal from '../../../../../components/common/ConfirmationModal';
import { IPlanOrder } from './Entities';

interface IProps {
    actions: IActions;
    planOrder: IPlanOrder;
    annotation: IAnnotationViewModel;
    availableStories: ISelect[];
    history: any;
    user: any;
}

interface IState {
    initialLoadDone: boolean;
    errors: any;
    upload: boolean;
    planOrder: IPlanOrder;
    showAnnotationModal: boolean;
    selectedAnnotationType: string;
    currentId?: number;
    showSendConfirmation: boolean;
    isSending: boolean;
    sendSuccess: boolean;
    isSaving: boolean;
}

class NewPlanOrder extends React.Component<IProps, IState> {
    private isZentuvoSite: boolean;

    constructor(props: any) {
        super(props);

        const { site } = window.appConfig;
        this.isZentuvoSite = site === getSiteName(Zentuvo);

        this.state = {
            initialLoadDone: false,
            errors: {},
            upload: false,
            planOrder: null,
            showAnnotationModal: false,
            currentId: null,
            showSendConfirmation: false,
            selectedAnnotationType: AnnotationNormal,
            isSending: false,
            sendSuccess: false,
            isSaving: false
        };

        this.uploadFiles = this.uploadFiles.bind(this);
        this.onUploadCompleted = this.onUploadCompleted.bind(this);
        this.deleteStorey = this.deleteStorey.bind(this);
        this.onFileUploadCompleted = this.onFileUploadCompleted.bind(this);
        this.sendPlanOrder = this.sendPlanOrder.bind(this);
        this.saveAnnotation = this.saveAnnotation.bind(this);
        this.redirect = this.redirect.bind(this);
        this.save = this.save.bind(this);
    }

    componentDidMount() {
        if (this.props.planOrder && this.props.planOrder.id) {
            let planOrder: IPlanOrder = assign({}, this.props.planOrder);

            if (this.state.initialLoadDone) {
                planOrder.extraInformation = this.props.planOrder.extraInformation;
                planOrder.isExpressDelivery = this.props.planOrder.isExpressDelivery;
            }

            this.props.actions.setPlanOrder(planOrder);

            this.setState({ initialLoadDone: true } as IState);
        }
    }

    onUploadCompleted() {
        this.setState({ upload: false } as IState);
    }

    uploadFiles() {
        this.setState({ upload: true } as IState);
    }

    onFileUploadCompleted(response: any) {
        response = response.xhr.response;

        if (response) {
            response = JSON.parse(response);
            this.props.actions.addStorey(response);
        }
    }

    toggleExpressDelivery = (e: any) => {
        this.props.actions.setPlanOrder({
            ...this.props.planOrder,
            isExpressDelivery: e.target.checked
        });
    };

    setExtraInformation = (e: any) => {
        this.props.actions.setPlanOrder({
            ...this.props.planOrder,
            extraInformation: e.target.value
        });
    };

    onChangeStorey(item: any, storeyIndex: number) {
        let value = item != null ? item.value : 0;

        if (value === undefined || value === null) {
            return;
        }

        let label = null;

        if (value === -1 || (item && typeof item.value === String.name.toLocaleLowerCase())) {
            value = -1;
            label = item.label;
        }

        this.updateStorey(this.props.planOrder.stories[storeyIndex].id, value, storeyIndex, label);
    }

    render() {
        const { apiUrl } = window.appConfig;

        return (
            <div>
                {this.props.planOrder && this.props.planOrder.id && (
                    <div>
                        {this.props.planOrder.isMeasured && (
                            <Panel bsStyle="warning">
                                <Panel.Heading>
                                    <Panel.Title>
                                        <div>
                                            <i className="material-icons">warning</i>
                                        </div>
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Body>
                                    {Translate('order/plan/measured/information')}
                                </Panel.Body>
                            </Panel>
                        )}
                    </div>
                )}
                {!this.props.planOrder.isMeasured && (
                    <div>
                        <Panel>
                            <Panel.Heading>
                                <Panel.Title>
                                    <span>
                                        {Translate(
                                            this.props.planOrder.canUploadImages
                                                ? 'order/plan/header'
                                                : 'order/plan/header/only-saving'
                                        )}
                                    </span>
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body>
                                {this.props.planOrder.canUploadImages && (
                                    <Dropzone
                                        actionUrl={`${apiUrl}/views/planorder/${this.props.planOrder.id}/storey`}
                                        upload={this.state.upload}
                                        onUploadCompleted={this.onUploadCompleted}
                                        onFileUploadCompleted={this.onFileUploadCompleted}
                                        uploadMultiple={true}
                                        removeFileAfterSuccess={true}
                                        acceptedFiles={
                                            'application/pdf,image/jpeg,image/png,image/gif'
                                        }
                                    />
                                )}
                            </Panel.Body>
                            <Panel.Footer>
                                {this.props.planOrder.canUploadImages && (
                                    <Row>
                                        <Col xs={12}>
                                            <Button
                                                bsStyle="info"
                                                className="pull-right"
                                                onClick={this.uploadFiles}
                                            >
                                                <i className="material-icons">cloud_upload</i>{' '}
                                                {Translate('order/plan/upload-button')}
                                            </Button>
                                        </Col>
                                    </Row>
                                )}
                            </Panel.Footer>
                        </Panel>
                        <hr />

                        {this.props.planOrder.stories &&
                            this.props.planOrder.stories.map((storey, index) => (
                                <div className="plan-sketch-storeys" key={index + 'storey.id'}>
                                    {this.props.planOrder.canUploadImages && (
                                        <div className="storey-tools no-space">
                                            <StoreySort
                                                index={index}
                                                storiesLength={this.props.planOrder.stories.length}
                                                moveUp={() => this.updateSort(storey.id, 'up')}
                                                moveDown={() => this.updateSort(storey.id, 'down')}
                                            />

                                            <FormGroup
                                                className="required storey-select no-space"
                                                validationState={FormValidationService.getValidationState(
                                                    this.state.errors[`stories[${index}]`]
                                                )}
                                            >
                                                <StoreySelect
                                                    key={'storey-select-' + index}
                                                    value={{
                                                        id: storey.storeyId,
                                                        name: storey.customStoreyName
                                                            ? storey.customStoreyName
                                                            : Translate(
                                                                  storey.availableStories &&
                                                                      storey.availableStories.find(
                                                                          (x) =>
                                                                              x.id ===
                                                                              storey.storeyId
                                                                      )
                                                                      ? storey.availableStories.find(
                                                                            (x) =>
                                                                                x.id ===
                                                                                storey.storeyId
                                                                        ).name
                                                                      : ''
                                                              )
                                                    }}
                                                    options={storey.availableStories}
                                                    onChange={(e: any) =>
                                                        this.onChangeStorey(e, index)
                                                    }
                                                />
                                                <HelpBlock>
                                                    {this.state.errors[`stories[${index}]`]}
                                                </HelpBlock>
                                            </FormGroup>
                                        </div>
                                    )}
                                    {!this.props.planOrder.canUploadImages && (
                                        <FormGroup>
                                            <FormControl.Static>
                                                {storey.storeyId > 0
                                                    ? Translate(
                                                          storey.availableStories.find(
                                                              (x) => x.id === storey.storeyId
                                                          ).name
                                                      )
                                                    : storey.customStoreyName}
                                            </FormControl.Static>
                                        </FormGroup>
                                    )}

                                    <img
                                        src={`${apiUrl}/file/${
                                            storey.revision && storey.revision.thumbnailReference
                                                ? storey.revision.thumbnailReference
                                                : storey.file.thumbnailReference
                                        }`}
                                    />

                                    {this.props.planOrder.canUploadImages && (
                                        <div>
                                            <ButtonGroup className="block">
                                                <Button
                                                    bsStyle="info"
                                                    onClick={() =>
                                                        this.annotateStorey(storey.id, index)
                                                    }
                                                >
                                                    <i className="material-icons">mode_edit</i>{' '}
                                                    {Translate('order/plan/storey/annotate-button')}
                                                </Button>
                                                <Button
                                                    bsStyle="danger"
                                                    onClick={() =>
                                                        this.deleteStorey(storey.id, index)
                                                    }
                                                >
                                                    <i className="material-icons delete">
                                                        delete_forever
                                                    </i>{' '}
                                                    {Translate('order/plan/storey/delete-button')}
                                                </Button>
                                            </ButtonGroup>
                                            <hr />
                                        </div>
                                    )}
                                </div>
                            ))}

                        <Row>
                            <Col xs={2}>
                                {!this.isZentuvoSite && (
                                    <Checkbox
                                        name="isExpressDelivery"
                                        checked={
                                            this.props.planOrder.isExpressDelivery
                                                ? this.props.planOrder.isExpressDelivery
                                                : false
                                        }
                                        onChange={this.toggleExpressDelivery}
                                    >
                                        <span>{Translate('order/plan/express-delivery-checkbox')}</span>
                                    </Checkbox>
                                )}
                            </Col>
                            <Col xs={6}>
                                {this.props.planOrder.isExpressDelivery && (
                                    <Panel>
                                        <Panel.Body>
                                            <Row>
                                                <Col xs={2}>
                                                    <i className="material-icons material-icons-info no-label md-60">
                                                        info
                                                    </i>
                                                </Col>
                                                <Col xs={10}>
                                                    <Row>
                                                        <b>
                                                            {Translate(
                                                                'order/plan/express-delivery-checkbox/information/cost'
                                                            )}
                                                        </b>
                                                    </Row>
                                                    <Row>
                                                        {Translate(
                                                            'order/plan/express-delivery-checkbox/information/deadline'
                                                        )}
                                                    </Row>
                                                    <Row>
                                                        <i>
                                                            {Translate(
                                                                'order/plan/express-delivery-checkbox/information/late'
                                                            )}
                                                        </i>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Panel.Body>
                                    </Panel>
                                )}
                            </Col>
                        </Row>

                        <FormGroup>
                            <ControlLabel>{Translate('order/plan/extra-information')}</ControlLabel>
                            <FormControl
                                componentClass="textarea"
                                name="extraInformation"
                                value={
                                    this.props.planOrder.extraInformation
                                        ? this.props.planOrder.extraInformation
                                        : ''
                                }
                                onChange={this.setExtraInformation}
                            />
                        </FormGroup>

                        {this.props.planOrder.canSendToPlan && (
                            <Button
                                bsStyle="primary"
                                className="pull-right"
                                onClick={() =>
                                    this.setState({
                                        showSendConfirmation: true
                                    } as IState)
                                }
                                disabled={
                                    this.state.isSending ||
                                    this.state.sendSuccess ||
                                    !this.props.planOrder.stories ||
                                    this.props.planOrder.stories.length < 1
                                }
                            >
                                {Translate('order/plan/send-button')}{' '}
                                {this.state.isSending && <i className="load-spin-dark" />}
                            </Button>
                        )}

                        {!this.props.planOrder.canSendToPlan && (
                            <Button
                                bsStyle="primary"
                                className="pull-right"
                                onClick={this.save}
                                disabled={this.state.isSaving}
                            >
                                {Translate('order/plan/save-button')}{' '}
                                {this.state.isSaving && <i className="load-spin-dark" />}
                            </Button>
                        )}

                        {window.location.search.includes('newOrder=1') && (
                            <Button
                                bsStyle="default"
                                className="pull-right"
                                onClick={() => this.redirect(this.props.user)}
                                disabled={this.state.isSending || this.state.sendSuccess}
                            >
                                {Translate('order/plan/skip-upload')}
                            </Button>
                        )}

                        {this.state.showAnnotationModal && this.props.annotation && (
                            <PlanAnnotationTool
                                annotation={this.props.annotation}
                                save={this.saveAnnotation}
                                storeys={this.props.availableStories}
                                close={() =>
                                    this.setState({
                                        showAnnotationModal: false
                                    } as IState)
                                }
                                type={this.state.selectedAnnotationType}
                                user={this.props.user}
                                address={this.props.planOrder.addressLine1}
                            />
                        )}
                        {this.state.showSendConfirmation && (
                            <ConfirmationModal
                                title={Translate('order/plan/send/confirmation/title')}
                                text={Translate('order/plan/send/confirmation/text')}
                                doButtonLabel={Translate('order/plan/send/confirmation/do-button')}
                                cancelButtonLabel={Translate(
                                    'order/plan/send/confirmation/cancel-button'
                                )}
                                doButtonStyle="danger"
                                do={this.sendPlanOrder}
                                closeModal={() =>
                                    this.setState({
                                        showSendConfirmation: false
                                    } as IState)
                                }
                            />
                        )}
                    </div>
                )}
            </div>
        );
    }

    updateSort(id: number, direction: 'up' | 'down') {
        this.props.actions
            .updateSort(this.props.planOrder.id, {
                id: id,
                direction: direction
            })
            .catch(() => {
                notify.failure(Translate('order/plan/error/sort'));
            });
    }

    updateStorey(
        planOrderStoreyId: number,
        storeyId: number,
        storeyIndex: number,
        customLabel?: string
    ) {
        this.props.actions
            .updateStorey(this.props.planOrder.id, planOrderStoreyId, {
                storeyId: storeyId,
                customStoreyName: customLabel
            })
            .then(() => {
                let errors = assign({}, this.state.errors);
                delete errors[`stories[${storeyIndex}]`];
                this.setState({ errors: errors } as IState);
            })
            .catch(() => {
                notify.failure(Translate('order/plan/error/storey'));
            });
    }

    sendPlanOrder() {
        this.setState({ isSending: true } as IState);
        this.props.actions
            .sendPlanOrder(this.props.planOrder.id, this.props.planOrder as ISendPlanOrderModel)
            .then(() => {
                notify.success(Translate('order/plan/send-success'));
                this.redirect(this.props.user);
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors } as IState);
                    this.setState({ isSending: false } as IState);
                })
            );
    }

    save() {
        this.setState({ isSaving: true } as IState);
        this.props.actions
            .savePlanOrder(this.props.planOrder.id, this.props.planOrder as ISavePlanOrderModel)
            .then(() => {
                notify.success(Translate('order/plan/save-success'));
                this.setState({ isSaving: false } as IState);
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ isSaving: false } as IState);
                })
            );
    }

    redirect(user: any) {
        if (Features.hasFeature(Features.ListOrders, user)) {
            this.props.history.push('/orders');
        }
    }

    showAnnotationModal(id: number) {
        this.props.actions.editAnnotation(id).then(() => {
            this.setState({
                showAnnotationModal: true,
                currentId: id
            } as IState);
        });
    }

    saveAnnotation(
        planOrderStoreyFileId: number,
        data: any,
        revisionType: number,
        annotationType: string,
        hasDoneCrop: boolean = false
    ) {
        if (annotationType === AnnotationNormal) {
            return this.props.actions.saveAnnotation(
                planOrderStoreyFileId,
                data,
                revisionType,
                hasDoneCrop,
                annotationType
            );
        } else if (annotationType === AnnotationFloorCrop) {
            return this.props.actions
                .createStorey(this.props.planOrder.id, data.upload)
                .then((result) => {
                    let id = result.stories[result.stories.length - 1].file.id;
                    if (data.canvasContent) {
                        data.upload = data.revisionUpload;
                        delete data.revisionUpload;
                        return this.props.actions.saveAnnotation(
                            id,
                            data,
                            revisionType,
                            false,
                            annotationType
                        );
                    }

                    return result;
                });
        }
    }

    annotateStorey(storeyId: number, index: number) {
        this.setState({ selectedAnnotationType: AnnotationNormal } as IState);
        this.showAnnotationModal(this.props.planOrder.stories[index].file.id);
    }

    deleteStorey(storeyId: number, index: number) {
        this.props.actions
            .deleteStorey(this.props.planOrder.id, storeyId)
            .then(() => {
                notify.success(Translate('order/plan/delete-storey/success'));
            })
            .catch(() => {
                notify.failure(Translate('order/plan/error/delete'));
            });
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        planOrder: ownProps.planOrder,
        availableStories: ownProps.availableStories,
        annotation: ownProps.annotation,
        user: state.user
    };
}

function mapDispatchToProps(dispatch: any): { actions: IActions } {
    return {
        actions: {
            deleteStorey: (planOrder: number, storeyId: number) =>
                dispatch(actions.deleteStorey(planOrder, storeyId)),
            addStorey: (storey: any) => dispatch(actions.addStorey(storey)),
            sendPlanOrder: (planOrderId: number, planOrder: ISendPlanOrderModel) =>
                dispatch(actions.sendPlanOrder(planOrderId, planOrder)),
            savePlanOrder: (planOrderId: number, planOrder: ISavePlanOrderModel) =>
                dispatch(actions.savePlanOrder(planOrderId, planOrder)),
            updateStorey: (planOrderId: number, planOrderStoreyId: number, data: IUpdateStorey) =>
                dispatch(actions.updatePlanOrder(planOrderId, planOrderStoreyId, data)),
            editAnnotation: (id: number) => dispatch(actions.editAnnotation(id, AnnotationNormal)),
            saveAnnotation: (
                planOrderRowRevisionId: number,
                data: string,
                revisionType: number,
                hasDoneCrop: boolean,
                annotationType: string
            ) =>
                dispatch(
                    actions.saveAnnotation(
                        planOrderRowRevisionId,
                        data,
                        hasDoneCrop,
                        revisionType,
                        annotationType
                    )
                ),
            updateSort: (planOrderId: number, storey: IUpdateSortModel) =>
                dispatch(actions.updatePlanOrderStoreySort(planOrderId, storey)),
            createStorey: (planOrderId: number, data: any) =>
                dispatch(actions.createStorey(planOrderId, data)),
            setPlanOrder: (planOrder: IPlanOrder) => dispatch(actions.setPlanOrder(planOrder))
        }
    };
}

interface IActions {
    deleteStorey: (planOrder: number, storeyId: number) => Promise<any>;
    addStorey: (storey: any) => Promise<any>;
    sendPlanOrder: (planOrderId: number, planOrder: ISendPlanOrderModel) => Promise<any>;
    savePlanOrder: (planOrderId: number, planOrder: ISavePlanOrderModel) => Promise<any>;
    updateStorey: (
        planOrderId: number,
        planOrderStoreyId: number,
        data: IUpdateStorey
    ) => Promise<any>;
    editAnnotation: (id: number) => Promise<any>;
    saveAnnotation: (
        planOrderRowRevisionId: number,
        data: string,
        revisionType: number,
        hasDoneCrop: boolean,
        annotationType: string
    ) => Promise<any>;
    updateSort: (planOrderId: number, storey: IUpdateSortModel) => Promise<any>;
    createStorey: (planOrderId: number, data: any) => Promise<any>;
    setPlanOrder: (planOrder: IPlanOrder) => Promise<any>;
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NewPlanOrder));
